<!-- Main container -->
@if (storageGroup$ | async; as storageGroup) {
  <div class="layout-col full">
    <elder-table
      class="flex"
      matSort
      [elderTableActivation]="{}"
      [data]="data"
      [selectionVisible]="false"
      [activeItem]="this.activeItem$ | async"
      (activeItemChange)="this.changeActiveItem($event)"
    >
      <elder-data-toolbar *elderTableToolbar [canMore]="false" [canAdd]="false" [canRemove]="false">
        <ng-template elderToolbarContent="left.actions"> </ng-template>
      </elder-data-toolbar>
      <ng-container matColumnDef="icon">
        <th *matHeaderCellDef mat-header-cell style="width: 1%"></th>
        <td mat-cell *matCellDef="let row">
          @if (row.hasChildren) {
            <div class="layout-row place-start-center gap-sm">
              <mat-icon>inventory_2</mat-icon>
            </div>
          }
        </td>
      </ng-container>
      <!-- StorageLocation / PackageNumber -->
      <ng-container matColumnDef="number">
        <th *matHeaderCellDef mat-header-cell>{{ 'storage.location' | translate }}</th>
        <td mat-cell *matCellDef="let row">
          @if (row.hasChildren) {
            <div>
              @if (!row.isUnassigned) {
                <span class="bold">{{ row?.storagePath.serialize() }}</span>
              } @else {
                <span class="bold">{{ 'context.unassigned' | translate }}</span>
              }
            </div>
          }
          @if (!row.hasChildren) {
            <div class="layout-row place-start-center gap-sm">
              <span>{{ row?.packageNumber }}</span>
            </div>
          }
        </td>
      </ng-container>
      <!-- weight -->
      <ng-container matColumnDef="weight">
        <th *matHeaderCellDef elderNumberCell mat-header-cell style="width: 10%">
          {{ 'context.weight' | translate }}
        </th>
        <td *matCellDef="let row" elderNumberCell mat-cell>
          @if (!row.hasChildren) {
            <div>
              {{ row?.packageWeight | elderQuantity: false : unitKg : '1.0-0' }}
            </div>
          }
        </td>
      </ng-container>
      <!-- state -->
      <ng-container matColumnDef="state">
        <th *matHeaderCellDef elderNumberCell mat-header-cell style="width: 15%">
          {{ 'packages.confirmationState.title' | translate }}
        </th>
        <td *matCellDef="let row" elderNumberCell mat-cell>
          @if (!row.hasChildren) {
            <div>
              {{ 'packages.confirmationState.' + row?.package?.confirmationState | translate }}
            </div>
          }
        </td>
      </ng-container>
      <!-- actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
        <td mat-cell *matCellDef="let row">
          <div class="layout-col place-center-center">
            @if (row.hasChildren) {
              <button
                mat-icon-button
                elderStopEventPropagation
                [disabled]="!canMove(row?.packageNodeGroup)"
                (click)="onMove(row?.packageNodeGroup)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            }
          </div>
        </td>
      </ng-container>
    </elder-table>
  </div>
}
